import { useConsent } from "../context/ConsentContext";
import { Button } from "@/components/ui/button";

export default function CookieConsent() {
  const { consent, setConsent } = useConsent();

  if (consent) return null; // already decided

  return (
    <div className="cookie-banner fixed w-full bottom-0 left-0 bg-[#F9F8F6] border border-[#E5E5E5]" role="dialog" aria-live="polite" aria-label="Cookie consent">
      <div className="max-w-7xl mx-auto flex items-center p-4">
      <p>
        We use cookies to improve your experience and analyse site traffic.
      </p>
      <div className="cookie-banner-actions ml-auto flex">
        <Button onClick={() => setConsent("declined")} className="cookie-btn cookie-btn-secondary mr-2 bg-[#F9F8F6] border border-[#0D0D0D] text-[#0D0D0D] hover:bg-[#000000] hover:text-[#FFFFFF]">
          Decline
        </Button>
        <Button onClick={() => setConsent("accepted")} className="cookie-btn cookie-btn-primary bg-[#000000] border border-[#0D0D0D] text-[#FFFFFF] hover:bg-[#F9F8F6] hover:text-[#0D0D0D]">
          Accept
        </Button>
      </div>
      </div>
    </div>
  );
}